import { useMutation, gql } from '@apollo/client';

export const ClearSelectedItems = gql`
    mutation ClearSelectedItems {
        updateMainDirectoryClearSelectedItems
    }
`;

export const useUpdateMainDirectoryClearSelectedItems = () => useMutation<boolean>(ClearSelectedItems);
